var e,
    r,
    t,
    i = require("elliptic"),
    n = require("did-jwt"),
    o = require("did-jwt-vc"),
    s = (e = require("ethr-did-resolver")) && "object" == typeof e && "default" in e ? e.default : e,
    a = require("web-did-resolver"),
    c = require("did-resolver"),
    u = require("mnid");

function l() {
  return (l = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];

      for (var i in t) {
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      }
    }

    return e;
  }).apply(this, arguments);
}

!function (e) {
  e.Function = "function", e.Event = "event", e.Constructor = "constructor", e.Fallback = "fallback";
}(r || (r = {})), function (e) {
  e.Pure = "pure", e.View = "view", e.NonPayable = "nonpayable", e.Payable = "payable";
}(t || (t = {}));

var d,
    f = function f(e) {
  if ("object" != typeof e) return !1;
  if (0 === Object.keys(e).length) return !0;

  for (var r = 0, t = ["from", "to", "data", "value", "gasPrice", "gas"]; r < t.length; r++) {
    if (t[r] in e) return !0;
  }

  return !1;
},
    v = function v(e, r) {
  for (var t = e.name + "(", i = e.inputs || [], n = 0; n < i.length; n++) {
    var o = i[n],
        s = o.type + " ";
    t += s += "string" === o.type ? '"' + r[n] + '"' : "" + r[n], i.length - 1 !== n && (t += ", ");
  }

  return t + ")";
},
    p = function p(e) {
  return function (t) {
    return {
      at: function at(i) {
        var n = {};
        return function (e) {
          return e.filter(function (e) {
            return e.type === r.Function && e.name && !e.constant;
          });
        }(t).forEach(function (r) {
          r.name && (n[r.name] = function () {
            var t = {},
                n = [].slice.call(arguments),
                o = (r.inputs || []).length;
            f(n[o]) && (t = n.splice(o, 1)[0]);
            var s = l({}, t, {
              to: i,
              function: v(r, n)
            });
            if (!e) return s;
            var a = n[n.length - 1];
            return e(s, a);
          });
        }), l({}, n, {
          abi: t,
          address: i
        });
      }
    };
  };
},
    h = new i.ec("secp256k1");

!function (e) {
  e.DISCLOSURE_REQUEST = "shareReq", e.DISCLOSURE_RESPONSE = "shareResp", e.TYPED_DATA_SIGNATURE_REQUEST = "eip712Req", e.VERIFICATION_SIGNATURE_REQUEST = "verReq", e.ETH_TX_REQUEST = "ethtx", e.PERSONAL_SIGN_REQUEST = "personalSigReq", e.PRESENTATION_REQUEST = "presentationReq";
}(d || (d = {}));

var y = function () {
  function e(e) {
    var r = e.did,
        t = e.address,
        i = e.privateKey,
        o = e.signer,
        d = e.ethrConfig,
        f = e.resolver;
    if (o ? this.signer = o : i && (this.signer = n.SimpleSigner(i)), r) this.did = r;else if (t) u.isMNID(t) && (this.did = "did:uport:" + t), t.match("^0x[0-9a-fA-F]{40}$") && (this.did = "did:ethr:" + t);else if (i) {
      var v = h.keyFromPrivate(i),
          p = n.toEthereumAddress(v.getPublic("hex"));
      this.did = "did:ethr:" + p;
    }
    if (f) this.resolver = f;else {
      var y = s.getResolver(d || {}),
          E = a.getResolver();
      this.resolver = new c.Resolver(l({}, E, y, {
        https: E.web
      }));
    }
  }

  e.createIdentity = function () {
    var e = h.genKeyPair(),
        r = e.getPublic("hex"),
        t = e.getPrivate("hex");
    return {
      did: "did:ethr:" + n.toEthereumAddress(r),
      privateKey: t
    };
  };

  var r = e.prototype;
  return r.signJWT = function (e, r) {
    return this.did && this.signer ? n.createJWT(e, {
      issuer: this.did,
      signer: this.signer,
      alg: this.did.match("^did:uport:") || u.isMNID(this.did) ? "ES256K" : "ES256K-R",
      expiresIn: r
    }) : Promise.reject(new Error("No Signing Identity configured"));
  }, r.createDisclosureRequest = function (e, r) {
    void 0 === e && (e = {}), void 0 === r && (r = 600);
    var t = {};

    if (e.requested && (t.requested = e.requested), e.verified && (t.verified = e.verified), e.claims && (t.claims = e.claims), e.notifications && (t.permissions = ["notifications"]), e.callbackUrl && (t.callback = e.callbackUrl), e.networkId && (t.net = e.networkId), e.rpcUrl) {
      if (!e.networkId) return Promise.reject(new Error("rpcUrl was specified but no networkId"));
      t.rpc = e.rpcUrl;
    }

    if (e.vc && (t.vc = e.vc), e.exp && (t.exp = e.exp), e.accountType) {
      if (!(["general", "segregated", "keypair", "none"].indexOf(e.accountType) >= 0)) return Promise.reject(new Error("Unsupported accountType " + e.accountType));
      t.act = e.accountType;
    }

    return e.boxPub && (t.boxPub = e.boxPub), this.signJWT(l({}, t, {
      type: d.DISCLOSURE_REQUEST
    }), e.exp ? void 0 : r);
  }, r.createVerification = function (e) {
    return this.signJWT({
      sub: e.sub,
      claim: e.claim,
      exp: e.exp,
      vc: e.vc,
      callbackUrl: e.callbackUrl
    });
  }, r.createVerificationSignatureRequest = function (e, r) {
    return this.signJWT({
      unsignedClaim: e,
      sub: r.sub,
      riss: r.riss,
      aud: r.aud,
      vc: r.vc,
      callback: r.callbackUrl,
      type: d.VERIFICATION_SIGNATURE_REQUEST,
      rexp: r.rexp
    }, r.expiresIn);
  }, r.createTypedDataSignatureRequest = function (e, r) {
    var t = void 0 === r ? {} : r,
        i = t.from,
        n = t.net,
        o = t.callback;

    try {
      for (var s = 0, a = ["types", "primaryType", "message", "domain"]; s < a.length; s++) {
        var c = a[s];
        if (!e[c]) throw new Error("Invalid EIP712 Request, must include '" + c + "'");
      }

      return Promise.resolve(this.signJWT({
        typedData: e,
        from: i,
        net: n,
        callback: o,
        type: d.TYPED_DATA_SIGNATURE_REQUEST
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  }, r.createPersonalSignRequest = function (e, r) {
    var t = void 0 === r ? {} : r;
    return this.signJWT({
      data: e,
      from: t.from,
      net: t.net,
      callback: t.callback,
      type: d.PERSONAL_SIGN_REQUEST
    });
  }, r.createTxRequest = function (e, r) {
    var t = void 0 === r ? {} : r,
        i = t.callbackUrl,
        n = t.exp,
        o = void 0 === n ? 600 : n,
        s = t.networkId,
        a = t.label,
        c = {};
    return i && (c.callback = i), s && (c.net = s), a && (c.label = a), this.signJWT(l({}, c, e, {
      type: d.ETH_TX_REQUEST
    }), o);
  }, r.createDisclosureResponse = function (e, r) {
    void 0 === e && (e = {}), void 0 === r && (r = 600);

    try {
      var t = function t() {
        return i.signJWT(l({}, e, {
          type: d.DISCLOSURE_RESPONSE
        }), r);
      },
          i = this,
          o = function () {
        if (e.req) return Promise.resolve(n.verifyJWT(e.req, {
          resolver: i.resolver
        })).then(function (r) {
          r.issuer && (e.aud = r.issuer);
        });
      }();

      return Promise.resolve(o && o.then ? o.then(t) : t());
    } catch (e) {
      return Promise.reject(e);
    }
  }, r.processDisclosurePayload = function (e) {
    var r = e.doc,
        t = e.payload;

    try {
      var i = this,
          o = t.own,
          s = void 0 === o ? {} : o,
          a = t.capabilities,
          c = void 0 === a ? [] : a,
          d = t.nad,
          f = t.dad,
          v = t.iss,
          p = t.boxPub,
          h = t.verified,
          y = function (e, r) {
        if (null == e) return {};
        var t,
            i,
            n = {},
            o = Object.keys(e);

        for (i = 0; i < o.length; i++) {
          r.indexOf(t = o[i]) >= 0 || (n[t] = e[t]);
        }

        return n;
      }(t, ["own", "capabilities", "aud", "req", "iat", "exp", "type", "nad", "dad", "iss", "boxPub", "verified"]),
          E = r.uportProfile,
          g = l({
        did: v,
        boxPub: p
      }, s, void 0 === E ? {} : E, y);

      f && (g.deviceKey = f), d && (g.mnid = d, g.address = u.decode(d).address), 1 === c.length && (g.pushToken = c[0]);

      var b = function () {
        if (h) {
          var e = [],
              r = h.map(function (r) {
            return n.verifyJWT(r, {
              resolver: i.resolver,
              audience: i.did
            }).catch(function () {
              return e.push(r), Promise.resolve(void 0);
            });
          });
          return Promise.resolve(Promise.all(r)).then(function (r) {
            var t = [];
            r.forEach(function (e) {
              e && t.push(l({}, e.payload, {
                jwt: e.jwt
              }));
            }), g.verified = t, g.invalid = e;
          });
        }
      }();

      return Promise.resolve(b && b.then ? b.then(function () {
        return g;
      }) : g);
    } catch (e) {
      return Promise.reject(e);
    }
  }, r.authenticateDisclosureResponse = function (e, r) {
    try {
      var t = this;
      return Promise.resolve(n.verifyJWT(e, {
        resolver: t.resolver,
        audience: t.did,
        callbackUrl: r,
        auth: !0
      })).then(function (e) {
        var r = e.payload,
            i = e.doc;
        if (r.req) return Promise.resolve(n.verifyJWT(r.req, {
          resolver: t.resolver,
          audience: t.did
        })).then(function (e) {
          var n = e.payload;
          if (n.type !== d.DISCLOSURE_REQUEST) throw new Error("Challenge payload type invalid: " + n.type);
          return t.processDisclosurePayload({
            payload: r,
            doc: i
          });
        });
        throw new Error("Challenge was not included in response");
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, r.verifyDisclosure = function (e) {
    try {
      var r = this;
      return Promise.resolve(n.verifyJWT(e, {
        resolver: r.resolver,
        audience: r.did
      })).then(function (e) {
        return r.processDisclosurePayload({
          payload: e.payload,
          doc: e.doc
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, r.issueVerifiableCredential = function (e) {
    try {
      return this.did && this.signer ? Promise.resolve(o.createVerifiableCredentialJwt(e, {
        did: this.did,
        signer: this.signer
      })) : Promise.reject(new Error("No Signing Identity configured"));
    } catch (e) {
      return Promise.reject(e);
    }
  }, r.verifyPresentation = function (e) {
    try {
      return Promise.resolve(o.verifyPresentation(e, this.resolver));
    } catch (e) {
      return Promise.reject(e);
    }
  }, r.contract = function (e) {
    var r = this;
    return p(function (e, t) {
      return e.function && (e.fn = e.function), delete e.function, r.createTxRequest(e, t);
    }.bind(this))(e);
  }, e;
}();

Object.defineProperty(exports, "SimpleSigner", {
  enumerable: !0,
  get: function get() {
    return n.SimpleSigner;
  }
}), exports.ContractFactory = p, exports.Credentials = y;